import { type AxiosInstance } from "axios"
import handleDownloadResult from "./util/handleDownloadResult"
import ProfessionalTypeKey from "mco-keys/src/t4/ProfessionalTypeKey"

class ProfessionalBulkAddClient {
	constructor(private axiosClient: AxiosInstance) {}

	private base = "/api/admin/professional/bulkadd"

	public downloadBulkAddTemplate = async (
		professionalTypeKey: ProfessionalTypeKey
	) => {
		const query = new URLSearchParams()
		query.append("professionalTypeKey", professionalTypeKey)
		const response = await this.axiosClient.get(
			`${this.base}/template?${query.toString()}`,
			{ responseType: "blob" }
		)
		handleDownloadResult("bulkadd_template.csv", response)
	}

	public consultants = (file: File) =>
		this.axiosClient.postForm<void>(`${this.base}/consultants`, {
			files: [file]
		})

	public teamMembers = (file: File) =>
		this.axiosClient.postForm<void>(`${this.base}/teamMembers`, {
			files: [file]
		})
}

export default ProfessionalBulkAddClient
